import {
  createInstance,
  getInstance,
} from '@module-federation/enhanced/runtime';
import { loadModuleFederationHostShared } from '@backstage/module-federation-common';
import type { ComponentType } from 'react';

import type { RemoteConfig } from './types';
import { extractComponent } from './utils';

const getOrCreateInstance = async () => {
  const existing = getInstance();
  if (existing) return existing;

  return createInstance({
    name: 'backstage',
    remotes: [],
    shared: await loadModuleFederationHostShared(),
  });
};

export const loadStandardRemote = async (
  remote: RemoteConfig,
  _remoteOrigin?: string,
): Promise<ComponentType> => {
  const instance = await getOrCreateInstance();

  instance.registerRemotes([{ name: remote.name, entry: remote.entry }], {
    force: true,
  });

  const module = await instance.loadRemote<Record<string, unknown>>(
    `${remote.name}/${remote.exposedModule}`,
    { from: 'runtime' },
  );

  return extractComponent(module, remote.name, remote.exposedModule);
};
